/**
 * Compares item timestamp in seconds with current time
 *
 * @param param0 Object with timestamp member. Assuming that timestamp is in seconds
 * @returns boolean: expired (false) or not (true)
 */
export const isNotExpired = ({ timestamp }: { timestamp: number }): boolean => {
  return (new Date().getTime() - timestamp * 1000) < 0
}

const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000

/**
 * Compares item timestamp in day with current day
 *
 * @param param0 Object with timestamp member. Assuming that timestamp is in seconds
 * @returns boolean: expired (false) or not (true)
 */
export const isNotExpiredDay = ({ timestamp }: { timestamp: number }): boolean => {
  return (new Date().getTime() - timestamp * 1000) < MILLISECONDS_PER_DAY
}
